import template from './profile.html';
class ProfileController {
}


export default {
    template: template,
    controller: ProfileController,
    bindings: {
        repositories: '='
    },
};


// WEBPACK FOOTER //
// ./views/profile/profile.controller.js